<nav aria-label="Stage navigation" data-testid="sidebar-nav" class="sidebar-nav">
  <button
    type="button"
    class="sidebar-header"
    data-testid="sidebar-home-link"
    aria-label="Back to Home"
    (click)="goHome()">
    @if (collapsed()) {
      <img
        class="az-logo az-logo-mark"
        src="assets/icons/az-only-logo.svg"
        alt="AstraZeneca"
        aria-hidden="true"
      />
    } @else {
      <img
        class="az-logo"
        src="assets/icons/white-logo.svg"
        alt="AstraZeneca"
        aria-hidden="true"
      />
      <div class="sidebar-branding">
        <span class="app-name">AZ Symphony</span>
        <span class="version-stamp">v0.1</span>
      </div>
    }
  </button>

  @if (showWorkflow()) {
    <ul class="stage-list" role="list">
      @for (stage of stages; track stage.name; let i = $index) {
        <li>
          <button
            class="stage-btn"
            [class.active]="activeIndex() === i && !completedIndices().has(i)"
            [class.completed]="completedIndices().has(i)"
            [class.locked]="isLocked(i)"
            [attr.aria-current]="activeIndex() === i && !completedIndices().has(i) ? 'page' : null"
            [attr.aria-label]="ariaLabelFor(stage, i)"
            [disabled]="isLocked(i)"
            [attr.aria-disabled]="isLocked(i) ? 'true' : null"
            (click)="onStageSelect(i)"
            [attr.data-testid]="'stage-item-' + i"
            type="button">
            @if (completedIndices().has(i)) {
              <mat-icon class="stage-icon completed">check_circle</mat-icon>
            } @else {
              <mat-icon class="stage-icon" [class.active]="activeIndex() === i">
                {{ stage.icon }}
              </mat-icon>
            }
            @if (!collapsed()) {
              <span class="stage-label-wrap">
                <span class="stage-label">{{ stage.name }}</span>
                @if (stage.aiPowered) {
                  <!-- Decorative: the aria-label suffix above is what screen readers hear -->
                  <span class="ai-marker" data-testid="ai-marker" aria-hidden="true">&#9733;</span>
                }
                @if (isGeneratingForStage(i)) {
                  <!-- Decorative: the aria-label suffix above is what screen readers hear -->
                  <span class="generating-marker" data-testid="generating-marker" aria-hidden="true"></span>
                }
              </span>
            }
          </button>
        </li>
      }
    </ul>

    <!-- AI-agent legend — explains the gold marker on AI-backed stages, hidden when collapsed for lack of room -->
    @if (!collapsed()) {
      <p class="ai-legend" data-testid="ai-legend">
        <span class="ai-marker" aria-hidden="true">&#9733;</span>
        Stages backed by a live AI agent
      </p>
    }

    <!-- SYM-3: AI cost and status meter — part of the workflow simulation, hidden on Home along with the rest -->
    <app-cost-meter />
  }
</nav>
